import { Container, CircularProgress, Box } from '@mui/material'
import Auth from '../auth/auth'
import { useAuthContext } from '../common/context/auth/auth-context'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

function Login() {
  const { session, loading, needsProfileSetup } = useAuthContext()
  const navigate = useNavigate()

  useEffect(() => {
    if (loading || !session) return
    navigate(needsProfileSetup ? '/set-password' : '/dashboard')
  }, [session, loading, needsProfileSetup, navigate])

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Container sx={{ py: { xs: 6.25, sm: 12.5 } }}>
      <Auth />
    </Container>
  )
}

export default Login